module.exports = __webpack_public_path__ + "assets/img/9icon.792e4c9a.png";